<template>
  <div class="upload-anexo-com-acoes">
    <b-form-file
      :value="value"
      :placeholder="placeholder"
      :accept="accept"
      :state="state"
      :disabled="disabled"
      style="flex-grow: 3; padding-right: 5px"
      @input="onInput"
    />
    <div
      v-if="mostrarBotaoDownload || mostrarBotaoRemover"
      class="acoes-anexo"
    >
      <b-button
        v-if="mostrarBotaoDownload"
        size="sm"
        class="mr-1"
        :disabled="disabled"
        @click="$emit('download-existente')"
      >
        <font-awesome-icon icon="download" />
      </b-button>
      <b-button
        v-if="mostrarBotaoRemover"
        size="sm"
        variant="outline-danger"
        :disabled="disabled"
        @click="onRemove"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "UploadAnexoComAcoes",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      required: false,
      default: null,
    },
    placeholder: {
      type: String,
      default: "Nenhum arquivo selecionado",
    },
    accept: {
      type: String,
      default: "",
    },
    state: {
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    nomeArquivoExistente: {
      type: String,
      required: false,
      default: null,
    },
    podeBaixar: {
      type: Boolean,
      default: false,
    },
    podeExcluir: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput(file: File | null) {
      this.$emit("input", file);
      this.$emit("change", file);
    },
    onRemove() {
      // Se existe arquivo salvo no backend, o pai decide como remover (normalmente com confirmação).
      if (this.nomeArquivoExistente) {
        this.$emit("remove-existente");
        return;
      }
      // Para arquivo apenas selecionado localmente (tela de criação), limpamos direto para dar agilidade.
      this.$emit("input", null);
      this.$emit("change", null);
    },
  },
  computed: {
    temArquivoSelecionado(): boolean {
      return !!this.value;
    },
    mostrarBotaoDownload(): boolean {
      return !!this.nomeArquivoExistente && this.podeBaixar;
    },
    mostrarBotaoRemover(): boolean {
      // Exibe remover tanto para arquivo já salvo quanto para arquivo recém-selecionado.
      return this.podeExcluir && (!!this.nomeArquivoExistente || this.temArquivoSelecionado);
    },
  },
});
</script>

<style scoped>
.upload-anexo-com-acoes {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.upload-anexo-com-acoes .custom-file {
  flex: 1 1 auto;
  min-width: 0;
}

.acoes-anexo {
  margin-bottom: 0;
  margin-left: 0.75rem;
  display: flex;
  flex: 0 0 auto;
  gap: 0.25rem;
}
</style>
